import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import './styles';
import store from './store';
import App from './App';
import { createAppRouter } from './routes/router';
import { APP_ENV } from './configs/appConfig';
import unregisterServiceWorker from './utils/unregisterServiceWorker';


if (import.meta.env.PROD && APP_ENV !== 'demo') {
  Sentry.init({
    dsn: 'https://9ede8b12f7f43cf6cb75635cb39ad5c4@sentry.olegb.dev/88',
    environment: APP_ENV,
    initialScope: { tags: { app: 'client_front' } },
  });
}

const router = createAppRouter();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App router={router} />
  </Provider>,
);

unregisterServiceWorker();
